export { default as Fail } from './Fail.svg';
export { default as Pass } from './Pass.svg';
